import React from 'react'
import hexToRgba from 'hex-to-rgba'
import { CircularProgressbar } from 'react-circular-progressbar'
import { GeneralProgressItemType } from '../../containers/ProfileAchievementsPage/types'

// Styles
import './styles.scss'

// Icons
import IconComplete from './images/iconComplete'

export default ({ item }: { item: GeneralProgressItemType }) => {
  return (
    <div className={'progress-circle-item'}>
      <div
        className={'outer'}
        style={{ backgroundColor: hexToRgba(item.color, 0.14) }}
      >
        <span className={'outer__title'}>
          {item.progress === item.all ? item.completeText : item.title}
        </span>
        <div className={'outer__circle'}>
          {item.progress === item.all ? (
            <div className={'complete'} style={{ backgroundColor: item.color }}>
              <IconComplete />
            </div>
          ) : (
            <CircularProgressbar
              value={(100 / item.all) * item.progress}
              text={`${item.progress}/${item.all}`}
              strokeWidth={14}
              styles={{
                path: {
                  stroke: hexToRgba(item.color),
                },
                text: {
                  fill: '#000',
                  fontSize: '12px',
                  fontFamily: 'Gencentre-SemiBold',
                  cursor: 'default',
                  userSelect: 'none',
                },
                trail: {
                  stroke: hexToRgba(item.color, 0.16),
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
